import { Component, OnInit, Input } from '@angular/core';
import { IAthlete } from '../stores/entities-store/athlete-results-store';

@Component({
  selector: 'app-related-athletes-pannel',
  templateUrl: './related-athletes-pannel.component.html',
  styleUrls: ['./related-athletes-pannel.component.scss']
})
export class RelatedAthletesPannelComponent implements OnInit {
  /**
   * Slide configuration.
   * http://kenwheeler.github.io/slick/
   */
  slideConfig;
  /**
   * Title of the panel
   *
   * @type {string}
   * @memberof RelatedAthletesPannelComponent
   */
  @Input()
  title: string;
  /**
   * Input of athletes to be show.
   *
   * @type {Array<IAthlete>}
   * @memberof RelatedAthletesPannelComponent
   */
  @Input()
  athletes: Array<IAthlete>;

  /**
   * Input for set if the component is loading.
   *
   * @type {boolean}
   * @memberof RelatedAthletesPannelComponent
   */
  @Input()
  isLoading: boolean = true;
  constructor() {

  }

  /**
   * {@inheritdoc}
   *
   * @memberof RelatedAthletesPannelComponent
   */
  ngOnInit() {
    this.slideConfig = {
      slidesToShow: this.athletes.length < 4 ? this.athletes.length : 4,
      initialSlide: 0,
      slidesToScroll: this.athletes.length < 4 ? this.athletes.length : 4,
      dots: true,
      responsive: [
        {
          breakpoint: 860,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
          }
        },
        {
          breakpoint: 700,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
          }
        },
        {
          breakpoint: 500,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          }
        }
      ]
    };
  }

}
